import type { ModuleManifest } from "./types";

export const accountsManifest: ModuleManifest = {
  // Identity
  name: "accounts",
  label: "Account",
  labelPlural: "Accounts",

  // coreBOS mapping
  coreBOSModule: "Accounts",
  wsidPrefix: "11x",

  // Type
  type: "standard",

  // Routes
  routes: {
    list: "/accounts",
    show: "/accounts/show/:id",
    create: "/accounts/create",
    edit: "/accounts/edit/:id",
  },

  // Navigation
  navigation: {
    icon: "BankOutlined",
    order: 5,
    group: "CRM",
  },

  // Routing
  routing: {
    keywords: [
      "account",
      "accounts",
      "company",
      "companies",
      "organization",
      "client",
      "customer",
    ],
    searchFields: ["accountname", "phone", "email1"],
    defaultSort: { field: "accountname", order: "asc" },
  },

  // Context
  context: {
    supported: true,
    entityKey: "accounts",
  },

  // Fields
  fields: [
    {
      name: "accountname",
      label: "Account Name",
      type: "string",
      required: true,
    },
    {
      name: "industry",
      label: "Industry",
      type: "picklist",
      options: [
        { value: "Technology", label: "Technology" },
        { value: "Finance", label: "Finance" },
        { value: "Healthcare", label: "Healthcare" },
        { value: "Manufacturing", label: "Manufacturing" },
        { value: "Retail", label: "Retail" },
        { value: "Other", label: "Other" },
      ],
    },
    { name: "phone", label: "Phone", type: "string" },
    { name: "email1", label: "Email", type: "string" },
    { name: "website", label: "Website", type: "string" },
    { name: "annual_revenue", label: "Annual Revenue", type: "currency" },
    { name: "employees", label: "Employees", type: "number" },
    { name: "rating", label: "Rating", type: "picklist" },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  // Relationships
  relationships: [
    {
      module: "Contacts",
      field: "account_id",
      relation: "one-to-many",
      label: "Contacts",
      icon: "UserOutlined",
      displayField: "lastname",
      secondaryField: "email",
    },
    {
      module: "Documents",
      relation: "many-to-many",
      label: "Documents",
      icon: "FileOutlined",
      displayField: "notes_title",
      secondaryField: "filename",
    },
    {
      module: "cbCalendar",
      field: "rel_id",
      relation: "one-to-many",
      label: "Events",
      icon: "CalendarOutlined",
      displayField: "subject",
      secondaryField: "date_start",
    },
  ],

  // Required fields
  requiredFields: ["accountname", "assigned_user_id"],

  // Mass edit - fields are dynamically loaded from filterFields
  // The MassActionBar receives all picklist/select fields from the filter configuration
  massEdit: {
    enabled: true,
  },
  viewStrategy: "bespoke",
};
